import en from './strings.en';

const ru = {
    title: 'Интегрируйте Поиск активных перевозчиков в свои бизнес-процессы',
    text: 'Настройте обмен данными между ATI.SU и вашим сервисом или учётной системой с помощью API. Это простой способ искать заинтересованных исполнителей и потенциальных партнёров в привычном ПО. ',
    getAccess: 'Получить доступ',
    details: 'Подробнее',
    accessLicense: 'Доступ к API платный — оплатить его можно как и любую другую лицензию.'
};

export default { ru, en: { ...ru, ...en} };
